import React, { useEffect, useState } from 'react';
import api from '../../../lib/axios';
import { useNavigate } from 'react-router-dom';
import { IconButton, useToast } from "@chakra-ui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function BlogDetail() {
    const toast = useToast();
    const idBlog = window.location.pathname.split('/').pop();
    const [blog, setBlog] = useState({});
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate('/Blog');
    }

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await api.get(`https://teaapitest.azurewebsites.net/Blogs/${idBlog}`);
                if (response.data.success) {
                    setBlog(response.data.data);
                } else {
                    toast({
                        title: response.data.message,
                        status: "warning",
                        duration: 3000,
                        isClosable: true,
                    });
                    navigate('/Blog');
                }
            } catch (error) {
                toast({
                    title: error,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
                navigate('/Blog');
            }
        };

        fetchBlogs();
    }, [idBlog, navigate, toast]);

    return (
        <div className='my-2'>
            <IconButton
                size="sm"
                colorScheme={'gray'}
                icon={<FontAwesomeIcon icon="fas fa-chevron-left"/>}
                onClick={handleGoBack}
            />
            <div className='flex flex-col my-4 '>
                <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7" style={{height: "300px"}}>
                    <img src={blog.fotoBlog} alt={blog.titulo} className="h-full w-full object-cover object-center group-hover:opacity-75" />
                </div>
                <div className='my-2'>
                    <div className='flex justify-between items-center'>
                        <h3 className="mt-4 mb-2 text-xl text-gray-900 font-bold">{blog.titulo}</h3>
                        <span className='bg-[#C7DDDA] rounded-3xl text-xs font-bold px-3 py-1'>Category</span>
                    </div>
                </div>
                <div className=''>
                    <p className="text-base font-medium text-gray-900 text-justify">{blog.descripcion}</p>
                </div>
            </div>
        </div>
    );
}

export default BlogDetail;
